import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractSelectComponent } from '../abstract-select.component';
import { FieldLabelComponent } from '../field-label/field-label.component';
import { MatError, MatFormField } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';
import { FieldErrorComponent } from '../field-error/field-error.component';

@Component({
  selector: 'hd-card-picker',
  standalone: true,
  imports: [
    FieldLabelComponent,
    MatFormField,
    TranslateModule,
    NgClass,
    MatError,
    FieldErrorComponent,
  ],
  templateUrl: './card-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardPickerComponent extends AbstractSelectComponent<
  string | number
> {}
